<template>
  <div>
    <!--<ul>
      <li
        v-for="(album, index) in albumList"
        :key="index">
        <h2>{{ album.artist }}: {{ album.title }}</h2>
        <ol>
          <li
            v-for="track in album.trackList"
            :key="track.trackNumber">
            {{ track.title }}
          </li>
        </ol>
      </li>
    </ul>-->
    <Search/>
  </div>
</template>

<script>
import { fb } from '@/services/firebase';
import Search from '@/components/Search.vue';

export default {
  name: 'home',
  components: {
    Search,
  },
  data() {
    return {
      albumList: [],
    };
  },
  /* firestore: {
    albumList: fb.firestore().collection('album'),
  }, */
};
</script>
